import type React from "react";
import { useEffect, useState } from "react";

const App = () => {
  const [hue, setHue] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setHue((prev) => (prev + 0.5) % 360);
    }, 50);
    return () => clearInterval(interval);
  }, []);

  const backgroundStyle: React.CSSProperties = {
    width: "100vw",
    height: "100vh",
    margin: 0,
    padding: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: `linear-gradient(
      45deg, 
      hsl(${hue}, 70%, 60%), 
      hsl(${(hue + 60) % 360}, 70%, 60%), 
      hsl(${(hue + 120) % 360}, 70%, 60%)
    )`,
    backgroundSize: "400% 400%",
    transition: "background 0.1s linear",
    overflow: "hidden",
    color: "white",
    fontFamily: "system-ui, -apple-system, sans-serif",
    textShadow: "0 2px 10px rgba(0,0,0,0.2)",
  };

  return (
    <div style={backgroundStyle}>
      <h1 style={{ fontSize: "3rem", fontWeight: "200", letterSpacing: "0.2em" }}>Prismglow</h1>
    </div>
  );
};

export default App;
